(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ooak-smart-crystal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getDubaiDate = () => {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Dubai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
      return `${values.year}-${values.month}-${values.day}`;
    };

    const readStoredIndex = (key, count) => {
      try {
        const saved = Number.parseInt(window.localStorage.getItem(key), 10);
        return Number.isInteger(saved) && saved >= 0 && saved < count ? saved : null;
      } catch (error) {
        return null;
      }
    };

    const storeIndex = (key, index) => {
      try {
        window.localStorage.setItem(key, String(index));
      } catch (error) {
        return;
      }
    };

    const chooseIndex = (count) => {
      if (window.crypto && window.crypto.getRandomValues) {
        const values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        return values[0] % count;
      }
      return Math.floor(Math.random() * count);
    };

    const initializeSmartCrystal = (section) => {
      if (section.dataset.smartCrystalReady === 'true') return;

      const button = section.querySelector('[data-smart-crystal-button]');
      const result = section.querySelector('[data-smart-crystal-result]');
      const cards = Array.from(section.querySelectorAll('[data-smart-crystal-card]'));
      if (!button || !result || cards.length === 0) return;

      section.dataset.smartCrystalReady = 'true';
      button.addEventListener('click', () => {
        const storageKey = `ooak-smart-crystal-${getDubaiDate()}`;
        let selectedIndex = readStoredIndex(storageKey, cards.length);

        if (selectedIndex === null) {
          selectedIndex = chooseIndex(cards.length);
          storeIndex(storageKey, selectedIndex);
        }

        cards.forEach((card, index) => {
          card.hidden = index !== selectedIndex;
        });

        result.hidden = false;
        button.hidden = true;
        const selectedHeading = cards[selectedIndex].querySelector('.smart-crystal__name');
        selectedHeading?.focus({ preventScroll: true });
        result.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-smart-crystal]').forEach(initializeSmartCrystal);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
